import { Observable } from 'rxjs'
import AxiosSubscriber from '../../factory/AxiosSubscriber'

export class DeleteAttachmentVersionAPI {
  constructor() {
    this.subscription = null
  }

  subscribe(orderId, fileId, versionId, reason, next, complete, error) {
    const token = localStorage.getItem('token')

    const httpConfig = {
      url: `/order/${orderId}/${fileId}/${versionId}/${reason}`,
      method: 'delete',
      headers: {
        Authorization: `Bearer ${token}`,
      },
    }

    let observable$ = new Observable((observer) => {
      return new AxiosSubscriber(observer, httpConfig)
    })

    this.subscription = observable$.subscribe({
      next: next,
      complete: complete,
      error: error,
    })
  }

  unsubscribe() {
    if (this.subscription !== undefined && this.subscription !== null) {
      this.subscription.unsubscribe()
    }
  }
}
